import {connect} from "react-redux";
import FseInventory from "./Inventory";
import {bindActionCreators} from "redux";
import {getInactiveFsesRequest, tollById, getFseInventoryRequest, callLogsRequest, tollPendingMeetingRequest, nearestPlazaFromOperatorLocationRequest} from "../../../../service/FasttagToll/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    getInactiveFsesResponse:state.FasttagToll.getInactiveFsesResponse,
    tollView:state.FasttagToll.tollView,
    getFseInventoryResponse:state.FasttagToll.getFseInventoryResponse,
    callLogsResponse:state.FasttagToll.callLogsResponse,
    tollPendingMeetingResponse:state.FasttagToll.tollPendingMeetingResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    nearestPlazaFromOperatorLocationResponse:state.FasttagToll.nearestPlazaFromOperatorLocationResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInactiveFsesRequest,
            tollById,
            getFseInventoryRequest,
            callLogsRequest,
            tollPendingMeetingRequest,
            documentUploadUrlPublic,
            nearestPlazaFromOperatorLocationRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FseInventory);
